export default "__VITE_ASSET__CVWoVpbJ__"